import { render, staticRenderFns } from "./classListClassparameterY.vue?vue&type=template&id=9a05b0fa"
import script from "./classListClassparameterY.vue?vue&type=script&lang=js"
export * from "./classListClassparameterY.vue?vue&type=script&lang=js"
import style0 from "./classListClassparameterY.vue?vue&type=style&index=0&id=9a05b0fa&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports